export default __webpack_public_path__ + "static/media/gallery-7.0881662a.jpg";